import { render, staticRenderFns } from "./tariff-fee-credit.vue?vue&type=template&id=428bb4da"
import script from "./tariff-fee-credit.vue?vue&type=script&lang=js"
export * from "./tariff-fee-credit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports